import {
	groupsCollection,
	groupRequestsCollection,
	firebase,
	storage,
	usersCollection,
} from '../../config/firebase';

let state = {
	group: {},
	groups: [],
	userRequests: [],
	groupPosts: [],
	joinedGroups: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	group: state => state.group,
	groups: state => state.groups,
	userRequests: state => state.userRequests,
	groupPosts: state => state.groupPosts,
	joinedGroups: state => state.joinedGroups,
	groupLoading: state => state.loading,
	groupNotification: state => state.notification,
};
let actions = {
	async getUserRequests({ commit }, payload) {
		groupRequestsCollection.onSnapshot(snapshot => {
			let requests = [];
			for (let doc of snapshot.docs) {
				if (doc.data().requested_by == payload) {
					requests.push({ id: doc.id, ...doc.data() });
				}
			}

			commit('setUserRequests', requests);
		});
	},
	async updateGroupImage({ commit }, payload) {
		if (payload['image'] && typeof payload['image'] != 'string') {
			let profile_image = payload['image'];
			let fileParts = profile_image.name.split('.');
			let filename = `${payload.id}.${fileParts[fileParts.length - 1]}`;
			await storage.ref(`/group/${filename}`).put(payload['image']);
			payload['image'] = await storage
				.ref(`group`)
				.child(filename)
				.getDownloadURL();
			let id = payload.id;
			delete payload.id;
			await groupsCollection.doc(id).update({ ...payload });
		}
	},
	async getGroup({ commit }, payload) {
		commit('setGroupLoading', true);
		groupsCollection.doc(payload).onSnapshot(async groupSnap => {
			let groupData = groupSnap.data();
			let requests = [];
			let requestSnaps = await groupRequestsCollection
				.where('requested_to', '==', payload)
				.get();
			for (let doc of requestSnaps.docs) {
				let data = doc.data();
				let userSnap = await usersCollection
					.doc(data.requested_by)
					.get();
				let userData = userSnap.data();
				requests.push({
					id: doc.id,
					by: doc.data().requested_by,
					name: userData.firstname + ' ' + userData.lastname,
				});
			}
			groupData['requests'] = requests;
			commit('setGroupData', { ...groupData, id: groupSnap.id });
			commit('setGroupLoading', false);
		});
	},
	async getGroups({ commit }, payload) {
		commit('setGroupLoading', true);
		groupsCollection
			.where('owner_id', '==', payload)
			.onSnapshot(async snapshot => {
				let groups = [];
				for (let doc of snapshot.docs) {
					let data = doc.data();
					let requests = [];
					let requestSnaps = await groupRequestsCollection
						.where('requested_to', '==', doc.id)
						.get();
					for (let doc of requestSnaps.docs) {
						requests.push({
							id: doc.id,
							by: doc.data().requested_by,
						});
					}
					data['requests'] = requests;
					groups.push({ id: doc.id, ...data });
				}
				commit('setGroupsData', groups);
				commit('setGroupLoading', false);
			});
	},
	async getJoinedGroups({ commit }, payload) {
		commit('setGroupLoading', true);
		groupsCollection
			.where('members', 'array-contains', payload)
			.where('owner_id', '!=', payload)
			.onSnapshot(async snapshot => {
				let groups = [];
				for (let doc of snapshot.docs) {
					let data = doc.data();
					let requests = [];
					let requestSnaps = await groupRequestsCollection
						.where('requested_to', '==', doc.id)
						.get();
					for (let doc of requestSnaps.docs) {
						requests.push({
							id: doc.id,
							by: doc.data().requested_by,
						});
					}
					data['requests'] = requests;
					groups.push({ id: doc.id, ...data });
				}
				commit('setJoinedGroupsData', groups);
				commit('setGroupLoading', false);
			});
	},
	async addGroup({ commit }, payload) {
		commit('setGroupLoading', true);
		payload['datetime'] = firebase.firestore.Timestamp.fromDate(new Date());
		await groupsCollection.add({ ...payload });
		commit('setGroupsNotification', {
			message: 'Group Created',
			type: 'success',
		});
		commit('setGroupLoading', false);
	},
	async editGroup({ commit }, payload) {
		commit('setGroupLoading', true);
		let id = payload.id;
		delete payload.id;
		await groupsCollection.doc(id).update({ ...payload });
		commit('setGroupsNotification', {
			message: 'Group Created',
			type: 'success',
		});
		commit('setGroupLoading', false);
	},
	async leaveGroup({ commit }, payload) {
		commit('setGroupLoading', true);
		let groupSnap = await groupsCollection.doc(payload.group_id).get();
		let groupData = groupSnap.data();
		let { members } = groupData;
		members = members.filter(member => member != payload.member_id);
		groupData['members'] = members;
		await groupsCollection.doc(payload.group_id).update({ ...groupData });
		commit('setGroupsNotification', {
			message: 'Group Update',
			type: 'success',
		});
		commit('setGroupLoading', false);
	},
	async deleteGroup({ commit }, payload) {
		commit('setGroupLoading', true);
		await groupsCollection.doc(payload).delete();
		commit('setGroupsNotification', {
			message: 'Group Deleted',
			type: 'success',
		});
		commit('setGroupLoading', false);
	},
	async addGroupPost({ commit }, payload) {
		commit('setGroupLoading', true);
		let media = payload.media;
		let group_id = payload.group_id;
		delete payload.group_id;
		if (media) {
			delete payload.media;
		}
		try {
			let uniqueId = groupsCollection.doc().id;
			if (media) {
				let fileNameParts = media.name.split('.');
				let fileExt = fileNameParts[fileNameParts.length - 1];
				let filename = `${uniqueId}.${fileExt}`;

				await storage.ref(`/group/${group_id}/${filename}`).put(media);
				payload['media'] = await storage
					.ref(`group/${group_id}`)
					.child(filename)
					.getDownloadURL();
			}
			payload['tags'] = [];
			payload['comments'] = [];
			payload['likes'] = [];
			payload['datetime'] = firebase.firestore.Timestamp.fromDate(
				new Date()
			);
			await groupsCollection
				.doc(group_id)
				.collection('posts')
				.doc(uniqueId)
				.set(payload);
			commit('setGroupsNotification', {
				message: 'Group Post Added',
				type: 'success',
			});
		} catch (err) {
			commit('setGroupsNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setGroupLoading', false);
		}
	},
	async getGroupPosts({ commit }, payload) {
		commit('setGroupLoading', true);
		groupsCollection
			.doc(payload)
			.collection('posts')
			.orderBy('datetime', 'desc')
			.onSnapshot(async groupSnaps => {
				let lc_groupPosts = [];
				for (let doc of groupSnaps.docs) {
					let data = doc.data();
					data.comments.reverse();
					let { comments } = data;
					let { user_id } = data;
					let userSnap0 = await usersCollection.doc(user_id).get();
					let userData0 = userSnap0.data();
					if (data.media) {
						data['media_type'] = await storage
							.refFromURL(data.media)
							.getMetadata();
						data['media_type'] =
							data['media_type'].contentType.split('/')[0];
					}
					data['profile_image'] = userData0.profile_image;
					data['likes'] = data.likes ? data.likes : [];
					data['name'] =
						userData0.firstname + ' ' + userData0.lastname;
					for (let comment of comments) {
						let { comment_by } = comment;
						let userSnap = await usersCollection
							.doc(comment_by)
							.get();
						let userData = userSnap.data();
						comment['profile_image'] = userData.profile_image;
						comment['comment_by'] =
							userData.firstname + ' ' + userData.lastname;
						comment['username'] = userData.username;
					}

					data.comments = comments;
					lc_groupPosts.push({
						id: doc.id,
						...data,
					});
				}

				commit('setGroupPostsData', lc_groupPosts);
				commit('setGroupLoading', false);
			});
	},
	async addGroupPostComment({ commit }, payload) {
		let post_id = payload.post_id;
		let group_id = payload.group_id;

		let postSnap = await groupsCollection
			.doc(group_id)
			.collection('posts')
			.doc(post_id)
			.get();
		delete payload['post_id'];
		delete payload['group_id'];
		let data = postSnap.data();
		let comments = data.comments;
		if (!comments) comments = [];
		comments.push({
			...payload,
			datetime: firebase.firestore.Timestamp.fromDate(new Date()),
		});
		data['comments'] = comments;
		await groupsCollection
			.doc(group_id)
			.collection('posts')
			.doc(post_id)
			.update({ ...data });
	},
	async addGroupPostLike({ commit }, payload) {
		let post_id = payload.post_id;
		let group_id = payload.group_id;

		let postSnap = await groupsCollection
			.doc(group_id)
			.collection('posts')
			.doc(post_id)
			.get();
		delete payload['post_id'];
		delete payload['group_id'];
		let data = postSnap.data();
		let likes = data.likes;
		if (!likes) likes = [];
		if (likes.includes(payload.by)) {
			likes = likes.filter(like => like != payload.by);
		} else {
			likes.push(payload.by);
		}
		data['likes'] = likes;
		await groupsCollection
			.doc(group_id)
			.collection('posts')
			.doc(post_id)
			.update({ ...data });
	},
	async requestJoinGroup({ commit, dispatch }, payload) {
		let owner_id = payload.owner_id;
		delete payload.owner_id;
		await groupRequestsCollection.add({
			...payload,
			datetime: firebase.firestore.Timestamp.fromDate(new Date()),
		});
		let groupSnap = await groupsCollection.doc(payload.requested_to).get();
		let groupData = groupSnap.data();
		console.warn(groupData);
		let { toggle } = groupData;
		toggle = toggle == undefined ? true : !toggle;

		await groupsCollection
			.doc(payload.requested_to)
			.update({ ...groupData, toggle });
		dispatch('setNotification', {
			message: 'requested to join your group',
			for: owner_id,
			user: payload.requested_by,
			group: payload.requested_to,
			type: 'group',
		});
		commit('setGroupsNotification', {
			message: 'rs',
			type: 'success',
		});
	},
	async cancelJoinGroup({ commit }, payload) {
		await groupRequestsCollection.doc(payload).delete();
		commit('setGroupsNotification', {
			message: 'rs',
			type: 'success',
		});
	},
	async acceptGroupRequest({ commit, dispatch }, payload) {
		console.warn(payload);
		await groupRequestsCollection.doc(payload.request_id).delete();
		let groupSnap = await groupsCollection.doc(payload.group_id).get();
		let groupData = groupSnap.data();

		let { members } = groupData;
		members.push(payload.user_id);

		groupData['members'] = members;
		dispatch('setNotification', {
			message: 'accepted your request to join group',
			for: payload.user_id,
			user: payload.owner_id,
			group: payload.group_id,
			type: 'group',
		});
		await groupsCollection.doc(payload.group_id).update({ ...groupData });
	},
	async rejectGroupRequest({ commit }, payload) {
		console.warn(payload);
		await groupRequestsCollection.doc(payload.request_id).delete();
		let groupSnap = await groupsCollection.doc(payload.group_id).get();
		let groupData = groupSnap.data();
		let { toggle } = groupData;
		toggle = toggle == undefined ? true : !toggle;
		await groupsCollection
			.doc(payload.group_id)
			.update({ ...groupData, toggle });
	},
};
let mutations = {
	setGroupData(state, payload) {
		state.group = payload;
	},
	setUserRequests(state, payload) {
		state.userRequests = payload;
	},
	setGroupPostsData(state, payload) {
		state.groupPosts = payload;
	},
	setGroupsData(state, payload) {
		state.groups = payload;
	},
	setJoinedGroupsData(state, payload) {
		state.joinedGroups = payload;
	},
	setGroupLoading(state, payload) {
		state.loading = payload;
	},
	setGroupsNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
